import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleResponsiveCarouselComponent } from './simple-responsive-carousel.component';
import { GenericLinkModule, MediaModule, PageComponentModule } from '@spartacus/storefront';
import { CustomCarouselModule } from '../carousel/carousel.module';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { CustomBannerModule } from '../banner/banner.module';
import { CarouselModule } from 'primeng/carousel';

@NgModule({
  declarations: [SimpleResponsiveCarouselComponent],
  imports: [
    CommonModule,
    PageComponentModule,
    MediaModule,
    CustomCarouselModule,
    GenericLinkModule,
    CustomBannerModule,
    CarouselModule,
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        ResponsiveCarouselComponent: {
          component: SimpleResponsiveCarouselComponent,
        },
      },
    } as CmsConfig),
  ],
  exports: [SimpleResponsiveCarouselComponent, CustomBannerModule],
})
export class SimpleResponsiveCarouselModule {}
